/* eslint-disable react/require-default-props */
import React from 'react';
import { string as stringType, shape as shapeType } from 'prop-types';
import { MedioComposableBannerRenderer } from './MedioComposableBannerRenderer';
import { MedioComposableBanner } from './MedioComposableBanner';

const MedioComposableBannerPreview = ({ componentId, componentClass = '', livePreviewData = null }) => {
  return (
    livePreviewData ? (
      <MedioComposableBannerRenderer
        data={livePreviewData}
        componentId={componentId}
        componentClass={componentClass}
      />
    ) : (
      <MedioComposableBanner
        componentId={componentId}
        componentClass={componentClass}
      />
    )
  );
};

MedioComposableBannerPreview.propTypes = {
  componentClass: stringType,
  componentId: stringType.isRequired,
  livePreviewData: shapeType({})
};

MedioComposableBannerPreview.displayName = 'MedioComposableBannerPreview';

export { MedioComposableBannerPreview };
